import { Dashboard, UnitsAdmin } from '@/components';

export const UnitsAdminPage = () => (
  <Dashboard>
    <UnitsAdmin />
  </Dashboard>
);
